"use client";

import { BSRRewindClock } from "./bsr/BSRRewindClock";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { RewindClock as LegacyRewindClock } from "./legacy/RewindClock";

export const RewindClock = createBSRExperimentIcon(
  LegacyRewindClock,
  BSRRewindClock
);
